import { render, staticRenderFns } from "./OrdersFlatList.vue?vue&type=template&id=83016770&scoped=true"
import script from "./OrdersFlatList.vue?vue&type=script&lang=js"
export * from "./OrdersFlatList.vue?vue&type=script&lang=js"
import style0 from "./OrdersFlatList.vue?vue&type=style&index=0&id=83016770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83016770",
  null
  
)

export default component.exports